import {number, object, SchemaOf, string} from 'yup';
import {EnvironmentType} from '../../../shared/model/EnvironmentType.model';
import {Environment, EnvironmentAttributes} from './Environment.model';

export type EnvironmentFormFields = {
  readonly type: string;
  readonly merchantId: number;
  readonly environmentId: number;
  readonly accessKey: string;
  readonly secretKey: string;
}

export type EnvironmentsFormFields<T extends EnvironmentFormFields> = {
  [EnvironmentType.SANDBOX]?: T
  [EnvironmentType.PRODUCTION]?: T
  [EnvironmentType.SHARED]?: T
}

export const envFormInitValues = (
  environment: Environment<EnvironmentAttributes>
): EnvironmentFormFields => ({
  type: environment.attributes.type,
  merchantId: environment.merchantId,
  environmentId: environment.id,
  accessKey: environment.accessKey,
  secretKey: environment.secretKey
});

export const envFormValidationSchema: SchemaOf<EnvironmentFormFields> =
  object().shape({
    type: string().defined(),
    merchantId: number().defined(),
    environmentId: number().defined(),
    accessKey: string().defined(),
    secretKey: string().defined()
  }).defined();
